import Vue from "vue";
import { get, has, camelCase, upperFirst } from "../lib/lodash-replace";

Vue.prototype.$_ = {
    get,
    has,
    camelCase,
    upperFirst,
};
